import React from "react";
import { func } from "prop-types";
import ModalCloseBtn from "@insightfulscience/atomic-react/Modal/Close";
import useHotKey, { KEY_ESCAPE } from "../hooks/useHotKey";

export const ModalClose = ({ onClick, ...props }) => {
	useHotKey(KEY_ESCAPE, onClick, [onClick]);
	return <ModalCloseBtn onClick={onClick} {...props} />;
};

ModalClose.propTypes = {
	onClick: func,
};
